import { MouseEvent, useCallback } from "react";

import CallEndIcon from "@mui/icons-material/CallEnd";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { grey } from "@mui/material/colors";
import useTheme from "@mui/material/styles/useTheme";

import { error, neutral } from "app/themes/colors";
import { DIALER_CALL_STATE_ON_HOLD } from "components/suno-dialer/constants";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import { useCallContext } from "hooks/use-twilio-call-context";

export default function ActionButtonsBlock() {
  const theme = useTheme();
  const {
    handleToggleMuteActiveCall,
    handleEndCall,
    activeCall,
    activeCallDetails
  } = useSunoDialer();

  const { currentCall } = useCallContext();

  const id = String(currentCall?.parameters.CallSid);

  const isOnHold = activeCallDetails?.state === DIALER_CALL_STATE_ON_HOLD;
  const isMuted = activeCall?.isMuted;

  const handleEndCallClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      handleEndCall(id);
    },
    [handleEndCall, id]
  );

  return (
    <Box sx={{ p: 2 }}>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="space-between"
        sx={{
          background: "hsla(9, 0%, 100%, 0.7)",
          p: 1.5,
          borderRadius: "16px",
          boxShadow: theme.shadows[3]
        }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            textTransform: "none",
            background: `${isMuted ? neutral[800] : grey[700]} !important`,
            display: isOnHold ? "none" : undefined,
            "&:hover": {
              background: `${neutral[700]} !important`,
              color: `white !important`,
              transform: "scale(1.05)"
            }
          }}
          onClick={(event) => {
            event.stopPropagation();
            handleToggleMuteActiveCall();
          }}
        >
          {isMuted ? (
            <>
              <MicIcon sx={{ pr: 1 }} /> Unmute
            </>
          ) : (
            <>
              <MicOffIcon sx={{ pr: 1 }} /> Mute
            </>
          )}
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            textTransform: "none",
            background: `${error[700]} !important`,

            "&:hover": {
              background: `${error[800]} !important`,
              color: `white !important`,
              transform: "scale(1.05)"
            }
          }}
          onClick={handleEndCallClick}
        >
          <CallEndIcon sx={{ pr: 1 }} /> End&nbsp;Call
        </Button>
      </Stack>
    </Box>
  );
}
